export interface IViewDefinition {
    _id: string;
    active: boolean;
    brand?: string;
    view_name: string;
    schema_id: string;
    sections: Partial<Record<SECTIONS, IViewDefinitionSection>>;
    name: string;
}

export interface IViewDefinitionSection {
    key: string;
    elements: IViewDefinitionElement[];
}

export interface ViewDefinitionFormatter {
    formatter: ViewDefinitionFormatterType;
    params?: string[];
}

export interface IViewDefinitionElement {
    type: string;
    reference: string;
    editable: boolean;
    formatters: {
        [name: string]: ViewDefinitionFormatter;
    };
    base: string;
    derived_from?: IViewDefinitionElement[];
    default_value?: string;
}

export enum SECTIONS {
    DETAILS = "details",
    SMALL_IMAGE = "small_image",
}

export enum ViewDefinitionFormatterType {
    Uppercase = "uppercase",
    Lowercase = "lowercase",
    SentenceCase = "sentence_case",
    CapitalizeWords = "capitalize_words",
    Truncate = "truncate",
    Width = "width",
    Date = "date",
}
